import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useState, useEffect } from 'react';

const empty = {
  companyId: '', bankServiceId: '', accountNumber: '',
  accountCurrency:'', clientBic:'', accountOwnerBic:'',
  defaultRptgReqdMsgNmId:'', defaultRptgPeriodType:'', defaultMsgIdPrefix:''
};

const AccountModal = ({ show, onHide, onSave, initial }) => {
  const [form, setForm] = useState(empty);
  useEffect(() => setForm(initial ?? empty), [initial]);
  const c = (f, v) => setForm({ ...form, [f]: v });

  return (
    <Modal show={show} onHide={onHide} centered size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>{initial ? 'Edit account' : 'New account'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className='mb-2'>
          <Col>
            <Form.Label>Company ID</Form.Label>
            <Form.Control type='number' value={form.companyId}
              onChange={e=>c('companyId',e.target.value)} />
          </Col>
          <Col>
            <Form.Label>BankService ID</Form.Label>
            <Form.Control type='number' value={form.bankServiceId}
              onChange={e=>c('bankServiceId',e.target.value)} />
          </Col>
        </Row>

        <Form.Group className='mb-2'>
          <Form.Label>Account number</Form.Label>
          <Form.Control value={form.accountNumber}
            onChange={e=>c('accountNumber',e.target.value)} />
        </Form.Group>

        <Row className='mb-2'>
          <Col>
            <Form.Label>Currency</Form.Label>
            <Form.Control value={form.accountCurrency}
              onChange={e=>c('accountCurrency',e.target.value)} />
          </Col>
          <Col>
            <Form.Label>Client BIC</Form.Label>
            <Form.Control value={form.clientBic}
              onChange={e=>c('clientBic',e.target.value)} />
          </Col>
          <Col>
            <Form.Label>Owner BIC</Form.Label>
            <Form.Control value={form.accountOwnerBic}
              onChange={e=>c('accountOwnerBic',e.target.value)} />
          </Col>
        </Row>

        {['defaultRptgReqdMsgNmId','defaultRptgPeriodType','defaultMsgIdPrefix']
          .map(f => (
            <Form.Group key={f} className='mb-2'>
              <Form.Label>{f}</Form.Label>
              <Form.Control value={form[f]} onChange={e=>c(f,e.target.value)} />
            </Form.Group>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onHide}>Cancel</Button>
        <Button variant='primary'  onClick={() => onSave(form)}>Save</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AccountModal;
